/* PAVENROD - script global. Charge en defer par la section pav-socle.
   Regles de ce fichier :
   - aucune variable globale, aucun appel reseau (hors widget Clear Fashion
     quand la page en contient un) ;
   - chaque module est isole : une erreur dans l'un n'arrete pas les autres ;
   - rien ici n'est necessaire a l'affichage : si ce fichier ne charge pas,
     le socle retire la classe pv-js et tout le contenu reste visible. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  if (root.hasAttribute('data-pv-ready')) { return; }
  root.setAttribute('data-pv-ready', '');

  function ready(fn) {
    if (doc.readyState !== 'loading') { fn(); } else { doc.addEventListener('DOMContentLoaded', fn); }
  }
  function safe(name, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) { console.warn('[pavenrod] ' + name, e); }
      return false;
    }
    return true;
  }

  /* 1. Apparition au defilement des elements .pv-rv.
     Le masquage initial (pavenrod.css) depend de la classe pv-js sur <html>.
     Un element plus haut que l'ecran est revele des qu'il entre, sinon le
     seuil de 12 % ne serait jamais atteint. */
  var io = null;
  function snap(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
  function show(el) {
    el.classList.add('pv-in');
    setTimeout(function () { snap(el); }, 800);
  }
  function initReveal(scope) {
    var els = (scope || doc).querySelectorAll('.pv-rv:not(.pv-in)');
    if (!els.length) { return; }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pv-in'); snap(el); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          if (e.intersectionRatio >= 0.12 || e.boundingClientRect.height > window.innerHeight) {
            io.unobserve(e.target);
            show(e.target);
          }
        });
      }, { threshold: [0, 0.12] });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2. Page courante dans la navigation du header : aria-current pour les
     lecteurs d'ecran, classe pv-cur sur <html> pour le soulignement
     (regle dans pavenrod-ux.css). */
  function markCurrent() {
    var p = location.pathname;
    if (p === '/') { return; }
    var found = false;
    doc.querySelectorAll('header-wrapper a[href]').forEach(function (a) {
      if (a.getAttribute('href') === p) { a.setAttribute('aria-current', 'page'); found = true; }
    });
    if (found) { root.classList.add('pv-cur'); }
  }

  /* 3. Accessibilite : les zones reellement defilables (sliders Eclipse,
     grilles) doivent etre atteignables au clavier. */
  function focusableScrollers() {
    doc.querySelectorAll('[data-slide-count], .collection-product-grid__products').forEach(function (el) {
      var scrollable = (el.scrollWidth - el.clientWidth > 8) || (el.scrollHeight - el.clientHeight > 8);
      if (scrollable && !el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); }
    });
  }
  function initScrollers() {
    var t = null;
    setTimeout(focusableScrollers, 600);
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(focusableScrollers, 400);
    });
  }

  /* 4. Indicateur de chargement : affiche seulement si une navigation
     interne ou un envoi de formulaire depasse 450 ms. Garde-fous : le voile
     ne capte jamais les clics (pointer-events none en CSS), il se coupe
     seul au bout de 8 s, et un clic annule par un autre script ne l'arme pas.
     Le voile entre dans la couche superieure du navigateur (popover) : il
     passe ainsi devant les tiroirs d'Eclipse (panier, recherche, filtres),
     qui sont des <dialog>. Navigateur sans popover : simple z-index.
     Deux sources : les clics sur un lien et les envois de formulaire (tous
     navigateurs), et l'API Navigation quand le navigateur l'a, qui signale
     aussi les changements de page lances par un script (formulaire envoye
     apres le controle anti-robot de Shopify, redirection vers le paiement). */
  function initLoader() {
    var el = doc.querySelector('[data-pv-load]');
    if (!el) { return; }
    var timer = null;
    var guard = null;
    function dessus(oui) {
      if (!el.showPopover || !el.hasAttribute('popover')) { return; }
      try { if (oui) { el.showPopover(); } else { el.hidePopover(); } } catch (e) { /* deja dans l'etat voulu */ }
    }
    function coupe() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (guard) { clearTimeout(guard); guard = null; }
      el.classList.remove('is-on');
      dessus(false);
    }
    function arme() {
      coupe();
      timer = setTimeout(function () {
        dessus(true);
        el.classList.add('is-on');
        guard = setTimeout(coupe, 8000);
      }, 450);
    }
    function later(e) {
      /* verifie defaultPrevented apres le passage de tous les ecouteurs */
      setTimeout(function () { if (!e.defaultPrevented) { arme(); } }, 0);
    }
    doc.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) { return; }
      if (a.target && a.target !== '_self') { return; }
      if (a.hasAttribute('download')) { return; }
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) { return; }
      if (u.pathname === location.pathname && u.search === location.search) { return; }
      later(e);
    });
    doc.addEventListener('submit', function (e) {
      if (e.defaultPrevented) { return; }
      var f = e.target;
      if (f && f.target && f.target !== '_self') { return; }
      later(e);
    });
    if (window.navigation && window.navigation.addEventListener) {
      window.navigation.addEventListener('navigate', function (e) {
        try {
          var d = e.destination;
          /* ancre, telechargement, changement d'adresse sans changement de page, autre site : rien */
          if (e.hashChange || e.downloadRequest != null || !d || d.sameDocument) { return; }
          if (new URL(d.url, location.href).origin !== location.origin) { return; }
          arme();
        } catch (err) { /* API partielle : les ecouteurs de clic et d'envoi suffisent */ }
      });
    }
    window.addEventListener('pageshow', coupe);
    window.addEventListener('pagehide', function () { if (timer) { clearTimeout(timer); timer = null; } });
  }

  /* 5. Applications tierces : Judge.me, francisation des libelles restes en
     anglais. Le vrai correctif est le reglage de langue de l'application ;
     ce filet ne surveille que les blocs Judge.me (plus toute la page).
     (Un ancien module visait l'iframe PBarNextFrame en la prenant pour un
     bandeau d'application : c'est la barre de previsualisation de Shopify,
     absente pour les visiteurs. Retire en octobre 2026.) */
  function initApps() {
    var D = {
      'Customer Reviews': 'Avis clients',
      'Write a review': 'Rédiger un avis',
      'Write a Review': 'Rédiger un avis',
      'Be the first to write a review': 'Soyez le premier à donner votre avis',
      'No reviews yet': 'Pas encore d’avis',
      'Cancel review': 'Annuler',
      'Submit Review': 'Envoyer l’avis',
      'reviews': 'avis',
      'review': 'avis'
    };
    function trEl(el) {
      el.childNodes.forEach(function (nd) {
        if (nd.nodeType !== 3) { return; }
        var v = nd.textContent.trim();
        if (Object.prototype.hasOwnProperty.call(D, v)) { nd.textContent = nd.textContent.replace(v, D[v]); }
      });
    }
    function tr(node) {
      if (node.nodeType !== 1) { return; }
      if (node.className && typeof node.className === 'string' && node.className.indexOf('jdgm') !== -1) { trEl(node); }
      node.querySelectorAll('[class*=jdgm]').forEach(trEl);
    }
    var seen = [];
    function watch(host) {
      if (seen.indexOf(host) !== -1) { return; }
      seen.push(host);
      tr(host);
      new MutationObserver(function (muts) {
        muts.forEach(function (m) { m.addedNodes.forEach(tr); });
      }).observe(host, { childList: true, subtree: true });
    }
    function hosts() {
      /* blocs Judge.me de plus haut niveau seulement */
      var out = [];
      doc.querySelectorAll('[class*=jdgm]').forEach(function (el) {
        var p = el.parentElement;
        if (!p || !p.closest('[class*=jdgm]')) { out.push(el); }
      });
      return out;
    }
    var k = 0;
    var tj = setInterval(function () {
      var hs = hosts();
      if (hs.length) {
        clearInterval(tj);
        hs.forEach(watch);
        /* fenetres ajoutees plus tard directement sous <body> (formulaire d'avis) */
        new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            m.addedNodes.forEach(function (nd) {
              if (nd.nodeType !== 1) { return; }
              if ((typeof nd.className === 'string' && nd.className.indexOf('jdgm') !== -1) || nd.querySelector('[class*=jdgm]')) {
                hosts().forEach(watch);
              }
            });
          });
        }).observe(doc.body, { childList: true });
      } else if (++k > 24) { clearInterval(tj); }
    }, 500);
    /* blocs Judge.me inseres plus tard ailleurs que sous <body> (widget d'avis charge en differe) */
    [3000, 7000, 12000].forEach(function (ms) {
      setTimeout(function () { hosts().forEach(watch); }, ms);
    });
  }

  /* 6. Clear Fashion : la feuille et le script officiels ne sont charges
     que si la page contient un widget, et sans bloquer le rendu. Les div
     clear-fashion-widgets sont rendus par pav-impact, pav-compare et un
     bloc de code de la fiche produit (gabarit produit-26). */
  function initClearFashion() {
    if (!doc.querySelector('.clear-fashion-widgets')) { return; }
    if (doc.querySelector('script[src*="clear-fashion.com/assets/widget.js"]')) { return; }
    var l = doc.createElement('link');
    l.rel = 'stylesheet';
    l.media = 'screen,print';
    l.href = 'https://cdn.clear-fashion.com/assets/clear_fashion_widget_v2.css';
    doc.head.appendChild(l);
    var s = doc.createElement('script');
    s.src = 'https://widgets.clear-fashion.com/assets/widget.js';
    s.async = true;
    doc.head.appendChild(s);
  }

  /* 7. Videos d'ambiance.
     a) video.pv-lazyvid (pav-atelier, pav-genres) : emises sans autoplay et
        en preload none, donc rien n'est telecharge au chargement de la
        page. Lecture quand le bloc approche de l'ecran, pause quand il en
        sort.
     b) Si le visiteur demande moins d'animations (reglage systeme) : aucune
        lecture, l'image de couverture reste affichee, et la video en
        lecture automatique du hero (pav-hero) est arretee. */
  var vio = null;
  function playVideo(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  function initVideos(scope) {
    var base = scope || doc;
    var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (calm) {
      base.querySelectorAll('.pv-hero video[autoplay]').forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
      return;
    }
    var vids = base.querySelectorAll('video.pv-lazyvid:not([data-pv-vid])');
    if (!vids.length) { return; }
    if (!('IntersectionObserver' in window)) { vids.forEach(playVideo); return; }
    if (!vio) {
      vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { playVideo(e.target); }
          else if (!e.target.paused) { e.target.pause(); }
        });
      }, { rootMargin: '200px 0px' });
    }
    vids.forEach(function (v) {
      v.setAttribute('data-pv-vid', '');
      vio.observe(v);
    });
  }

  /* 8. Typographie francaise : un « ? », « ! », « : », « ; » ou un guillemet
     fermant ne doit jamais se retrouver seul en debut de ligne (mesure :
     « Une question » / « ? L'atelier repond. » sur la page Contact). L'espace
     ordinaire tapee avant ces signes, et apres un guillemet ouvrant, devient
     insecable. Meme largeur : rien ne bouge a l'ecran, sauf la coupure
     fautive. Les textes restent saisis normalement dans l'editeur.
     Portee : contenu de la page et pied de page. Jamais les champs de
     saisie, le code, les donnees ni les blocs d'applications. */
  var TYPO_HORS = 'script,style,noscript,template,textarea,select,pre,code,svg,[contenteditable],[class*="jdgm"],[class*="alma"]';
  function initTypo(scope) {
    var racines = scope ? [scope] : doc.querySelectorAll('main, .pv-foot');
    Array.prototype.forEach.call(racines, function (racine) {
      var w = doc.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null);
      var lot = [];
      var n;
      while ((n = w.nextNode())) {
        if (!/ [?!:;\u00bb]|\u00ab /.test(n.nodeValue)) { continue; }
        var p = n.parentNode;
        if (!p || p.nodeType !== 1 || p.closest(TYPO_HORS)) { continue; }
        lot.push(n);
      }
      lot.forEach(function (t) {
        t.nodeValue = t.nodeValue.replace(/ ([?!:;\u00bb])/g, '\u00a0$1').replace(/\u00ab /g, '\u00ab\u00a0');
      });
    });
  }

  if (!safe('reveal', function () { initReveal(); })) { root.classList.remove('pv-js'); }
  doc.addEventListener('shopify:section:load', function (e) {
    safe('reveal:section', function () { initReveal(e.target); });
    safe('videos:section', function () { initVideos(e.target); });
    safe('typo:section', function () {
      var t = e.target;
      if (t && t.closest && (t.closest('main') || t.querySelector('.pv-foot'))) { initTypo(t); }
    });
  });
  ready(function () {
    safe('typo', function () { initTypo(); });
    safe('current', markCurrent);
    safe('scrollers', initScrollers);
    safe('loader', initLoader);
    safe('videos', function () { initVideos(); });
    safe('apps', initApps);
    safe('clearfashion', initClearFashion);
  });
})();